import React from 'react';
import $ from "jquery";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {
  setMaterialsTutorialFinished,
  setVisualizerTutorialFinished, setVisualizerTutorialStep,
  showMaterialsTutorial,
  showVisualizerTutorial
} from "../../actions/tutorialFunctions";
import Tutorial from "./tutorial";
// import ActionTypes from "../../misc/actionTypes";
// import {ContentType} from "../visComponents/constants";

class VisualizerTutorial extends Tutorial {

  static propTypes = {
    isMobile: PropTypes.bool.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      ringStyles: {
        left: 0,
        top: 0,
      }
    };
  }

  componentDidMount = () => {
    let nextStep = this.props.visualizerTutorialStep;
    if (document.kvConfig.visualizerOnly && !this.props.visualizerTutorialStep) {
      this.props.setVisualizerTutorialStep(1);
      nextStep = 1;
    } else if (nextStep === 2 && !this.props.isMobile) {
      this.props.setVisualizerTutorialStep(3);
      nextStep = 3;
    }
    if (nextStep === 3) {
      if (this.props.fabricatorSettings.enableSharing) {
        $(".tutorial-overlay--visualizer").fadeIn(300);
        this.showTutorialStep(nextStep);
      } else {
        this.exitTutorial(true);
      }
    } else {
      $(".tutorial-overlay--visualizer").fadeIn(300);
      this.showTutorialStep(nextStep);
    }
  };

  showTutorialStep = (nextStep = this.props.visualizerTutorialStep) => {
    switch (nextStep) {
      case 0: {
        this.scrollAndHighLightRing(".mainbuttons .mobilebutton--back-to-quote");
        break;
      }
      case 1: {
        if (this.props.isMobile) {
          this.scrollAndHighLightRing(".mainbuttons .mobilebutton--design", 0);
        } else {
          $("html, body").animate({scrollTop: 0}, 500, () => {
            const roomLayoutsOrIdeas = this.getRoomLayoutsOrIdeasStepLogic();
            if (roomLayoutsOrIdeas.selector) {
              this.changeHighlightRingPosition(roomLayoutsOrIdeas.selector);
            }
            $(".tutorial-step").fadeIn(300)
          });
        }
        break;
      }
      case 3: {
        // if (this.props.isMobile) {
          // $(document).trigger(ActionTypes.OPEN_MOBILE_NAVIGATION); // open navigation
          // $(document).trigger(ActionTypes.CHANGE_MOBILE_MENU_CONTENT_TYPE, [ContentType.Layout]); // set navigation type
        // } else {
        //   this.scrollAndHighLightRing(".mainbuttons .mobilebutton--share");
        // }
        this.scrollAndHighLightRing(".mainbuttons .mobilebutton--share");
        break;
      }
      default:
        break;
    }
  };

  scrollAndHighLightRing = (selector, scrollTop = document.body.scrollHeight) => {
    $("html, body").animate({scrollTop}, 500, () => {
      this.changeHighlightRingPosition(selector);
      $(".tutorial-step__ring, .tutorial-step").fadeIn(300, () => {
        if (this.props.isMobile) {
          setTimeout(() => {
            this.changeHighlightRingPosition(selector);
          }, 300)
        }
      })
    });
  };

  handleNextStepClick = () => {
    const nextStep = this.props.visualizerTutorialStep + 1;
    this.props.setVisualizerTutorialStep(nextStep);
    switch (nextStep) {
      case 1:
        this.exitTutorial();
        break;
      case 2: {
        if (this.props.isMobile) {
          setTimeout(() => {
            this.changeHighlightRingPosition(".des .mobilebutton--layout");
          }, 500)
        } else {
          this.exitTutorial();
        }
        break;
      }
      case 3: {
        if (this.props.isMobile) {
          this.changeHighlightRingPosition(".mainbuttons .mobilebutton--share");
        } else {
          this.exitTutorial(true);
        }
        break;
      }
    }
  };

  exitTutorial = (forever) => {
    $(".tutorial-overlay--visualizer").fadeOut(300, () => {
      this.props.showVisualizerTutorial(false);
      if (forever) {
        this.props.setMaterialsTutorialFinished(true);
        this.props.setVisualizerTutorialFinished(true);
        try {
          window.localStorage.setItem("materials_tutorial_finished", true);
          window.localStorage.setItem("visualizer_tutorial_finished", true);
        } catch (ex) { console.log("localStorage exception", ex); }
      }
    });
  };

  getHighLightButton = () => {
    switch (this.props.visualizerTutorialStep) {
      case 0: {
        return (
          <button className="mobilebutton mobilebutton--back-to-quote" onClick={this.handleNextStepClick}>
            <span className="mobilebutton-text">
              <FormattedMessage id="quoteButton"/>
            </span>
          </button>
        )
      }
      case 1: {
        if (this.props.isMobile) {
          return (
            <button className="mobilebutton mobilebutton--design" onClick={this.handleNextStepClick}>
              <span className="mobilebutton-text">
                <FormattedMessage id="mobileMenu.designButton"/>
              </span>
            </button>
          )
        }
        return this.getRoomLayoutsOrIdeasStepLogic().buttonComponent
      }
      case 2: {
        return (this.props.isMobile) ? (
          <button className="mobilebutton mobilebutton--layout"
                  onClick={this.handleNextStepClick}>
            <span className="mobilebutton-text">
              <FormattedMessage id="mobileMenu.designMenuLayout"/>
            </span>
          </button>
        ) : null
      }
      case 3: {
        return (
          <button className={"mobilebutton mobilebutton--share"} onClick={() => this.exitTutorial(true)}>
            <span className="mobilebutton-text">
              <FormattedMessage id="header.shareButton"/>
            </span>
          </button>
        )
      }
      default:
        return null
    }
  };

  getRoomLayoutsOrIdeasStepLogic = () => {
    const existingRoomLayout = document.querySelector(".tab.tab--room-layout");
    if (existingRoomLayout) {
      return {
        selector: ".nav-wrapper__tabs .tab.tab--room-layout",
        buttonComponent: (
          <div className="tab tab--room-layout" onClick={this.handleNextStepClick}>
            <span className="tab-text">
              <FormattedMessage id="desktop.nav.roomLayout"/>
            </span>
          </div>
        ),
        mainTranslate: "roomLayout",
      }
    }
    const existingRoomIdeas = document.querySelector(".tab.tab--room-ideas");
    if (existingRoomIdeas) {
      return {
        selector: ".nav-wrapper__tabs .tab.tab--room-ideas",
        buttonComponent: (
          <div className="tab tab--room-ideas" onClick={this.handleNextStepClick}>
            <span className="tab-text">
              <FormattedMessage id="desktop.nav.roomIdeas"/>
            </span>
          </div>
        ),
        mainTranslate: "roomIdeas",
      }
    }
    return {
      selector: "",
      mainTranslate: null,
      buttonComponent: null
    }
  }

  render() {
    const ringStyles = this.state.ringStyles;
    const texts = (this.props.isMobile) ? "mobile" : "desktop";
    const highlightButton = this.getHighLightButton();
    const mainTextId = ((this.props.visualizerTutorialStep === 1) && !this.props.isMobile
      && this.getRoomLayoutsOrIdeasStepLogic().mainTranslate === "roomIdeas")
      ? `tutorials.visualizerPage.${texts}.step${this.props.visualizerTutorialStep}b`
      : `tutorials.visualizerPage.${texts}.step${this.props.visualizerTutorialStep}`;
    const showText = !(this.props.visualizerTutorialStep === 2 && !this.props.isMobile);
    const showNextButton = this.props.visualizerTutorialStep < 3 && showText;
    return (
      <div className={"tutorial-overlay tutorial-overlay--visualizer"}>
        <div className={"tutorial"}>
          <div className="tutorial-main">
            <p className="tutorial-main__text bold">
              {showText ? <FormattedMessage id={mainTextId}/> : null}
            </p>
            <div className="tutorial-main__buttons">
              {showText ? (
                <button className="ui-button3 ui-button3--blue ui-button3--wide"
                        onClick={() => this.exitTutorial(true)} id="tutorial-close">
                  <FormattedMessage id="tutorials.visualizerPage.exitTutorialButton"/>
                </button>
              ) : null}
              {showNextButton ? (
                <button className="ui-button3 ui-button3--green ui-button3--wide pulsating--green"
                        onClick={this.handleNextStepClick} id="tutorial-next">
                  <FormattedMessage id="tutorials.visualizerPage.nextButton"/>
                </button>
              ) : null}
            </div>
          </div>
          <span className="tutorial-step__ring tutorial-step__ring--scale" style={{
            "transform": "translate("+ringStyles.left +"px, "+ringStyles.top +"px)"
          }}/>
          {highlightButton ? (
            <div className={"tutorial-step tutorial-step--" + this.props.visualizerTutorialStep} style={{
              left: ringStyles.left,
              top: ringStyles.top,
            }}>
              {highlightButton}
            </div>
          ) : null}
        </div>
      </div>
    )
  }

}

const mapStateToProps = (store) => {
  const {settings} = store.fabricatorState;
  return {
    windowWidth: store.serverState.windowWidth,
    visualizerTutorialStep: store.tutorialState.visualizerTutorialStep,
    fabricatorSettings: settings,
  };
};

export default connect(mapStateToProps, {
  showMaterialsTutorial,
  setMaterialsTutorialFinished,
  showVisualizerTutorial,
  setVisualizerTutorialFinished,
  setVisualizerTutorialStep
})(VisualizerTutorial);
